<template>
  <div class="content-center" id="center">
    <img class="banner" :src="bannerLink" alt="" srcset="" />
    <section class="nav-total" id="news">
      <section class="total-width nav">
        <swiper
          ref="swiperRef"
          v-if="swiperOptions.slidesPerView"
          :class="{ 'content-center-swiper': swiperOptions.slidesPerView > 4 }"
          :options="swiperOptions"
        >
          <swiper-slide
            class="per-nav"
            v-for="(item, index) in navArr"
            :key="index"
          >
            <div
              :class="activeNav === index ? 'acvive-title' : ''"
              class="per-nav-item"
              @click.stop.prevent="navChange(item, index)"
            >
              {{ item.name }}
            </div>
            <div :class="activeNav === index ? 'acvive-nav' : ''"></div>
          </swiper-slide>
        </swiper>
      </section>
    </section>
    <section class="total-width">
      <section class="detail">
        <section class="card" v-for="item in newsList" :key="item.id">
          <section class="card-content">
            <img class="cover-img" :src="item.picture" alt="" />
            <section class="content">
              <h4 class="h4">{{ item.title }}</h4>
              <p class="p-contnet">{{ item.introduction }}</p>
              <section class="time">
                <p></p>
                <a class="link white" @click.stop="handleClick(item)">
                  查看全文→
                </a>
              </section>
            </section>
          </section>
        </section>
      </section>
    </section>
  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import { newsData } from '@/common/util/data'
import { getNewsClassifyList, getNewsListByClassify } from '@/api/news'

import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
export default {
  metaInfo: metaInfo.News,
  components: { swiper, swiperSlide },
  data() {
    return {
      ...newsData,
      activeNav: 0,
      swiperOptions: {
        loop: false,
        slidesPerView: 0,
        thresholdDelta: 100,
      },
      newsList: [],
    }
  },
  computed: {
    queryType() {
      return this.$route.query.type
    }
  },
  watch: {
    queryType: {
      handler(val) {
        this.$nextTick(() => {
          setTimeout(() => {
            const item = this.navArr[val]
            this.navChange(item, +val)
          },300)
        })
      },
      immediate: true
    }
  },
  methods: {
    navChange(item, index) {
      this.activeNav = index
      this.$refs.swiperRef.swiper.slideTo(index)
      this.getNewsListByClassifyId(item.id)
    },
    // 跳转到资讯详情页
    handleClick(data) {
      this.$router.push(`/news/${data.id}`)
    },
    // 获取资讯分类列表
    async getNewsClassify() {
      const { data } = await getNewsClassifyList()
      this.swiperOptions.slidesPerView = data.list.length > 4 ? 4.7 : 4
      this.navArr = data.list

      const classifyId = this.navArr.length && this.navArr[0].id || ''
      if (classifyId) this.getNewsListByClassifyId(classifyId)
    },
    // 根据资讯分类ID获取资讯列表
    async getNewsListByClassifyId(id) {
      const { data } = await getNewsListByClassify(id)
      this.newsList = data.list
    },
  },
  created() {
    this.getNewsClassify()
  },
}
</script>

<style lang="less" scoped>
.content-center {
  background-color: #f9f9f9;

  &-swiper::after {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    height: 68px;
    width: 60px;
    height: 68px;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.06) 0%,
      rgba(255, 255, 255, 0.78) 21%,
      #ffffff 70%
    );
    z-index: 1;
  }

  .banner {
    width: 100%;
  }

  .nav-total {
    background-color: #fff;
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.05);
    position: relative;
    .nav {
      height: 68px;
      line-height: 68px;

      .per-nav {
        display: flex;
        align-items: center;
        flex-direction: column;
        font-weight: 600;
        cursor: pointer;

        &-item {
          width: 100%;
          text-align: center;
        }
      }
      .acvive-nav {
        height: 2px;
        width: 40px;
        background: #cd3324;
      }
      .acvive-title {
        color: #cd3324;
      }
    }
  }

  .detail {
    margin-top: 30px;
    padding-bottom: 60px;
    text-align: center;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;

    .card {
      width: 33.33%;
      margin-bottom: 50px;
      .card-content {
        width: 90%;
        margin-left: 5%;
        background-color: #fff;
        border-radius: 5px;
        transition: all .3s;
        .cover-img {
          width: 100%;
          height: 214px;
          object-fit: cover;
          border-radius: 5px 5px 0 0;
        }
        .content {
          padding: 20px 30px;
          text-align: left;
          .h4 {
            font-size: 18px;
            margin-bottom: 10px;
            height: 47px;
            line-height: 24px;
            text-overflow: ellipsis;

            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;

            display: -moz-box;
            -moz-line-clamp: 2;
            -moz-box-orient: vertical;

            overflow-wrap: break-word;
            word-break: break-all;
            white-space: normal;
            overflow: hidden;
          }
          .p-contnet {
            font-size: 14px;
            line-height: 20px;
            height: 81px;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;

            display: -moz-box;
            -moz-line-clamp: 4;
            -moz-box-orient: vertical;

            overflow-wrap: break-word;
            word-break: break-all;
            white-space: normal;
            overflow: hidden;
          }
          .time {
            margin-top: 18px;
            font-size: 12px;
            color: #999;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .link {
              width: 98px;
              height: 32px;
              line-height: 32px;
              text-align: center;
              background-color: #cd3324;
              cursor: pointer;
              border-radius: 2px;
            }
          }
        }
      }
      .card-content:hover {
        box-shadow: 2px 2px 6px rgba(153, 153, 153, 0.3);
        transform: translateY(-10px);
        .h4 {
          color: #cd3324;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
